import React from 'react';
import { withRouter } from 'react-router-dom';
import API from '../../../../utils/API';

import FieldModal from '../../../../components/modals/fieldModal';

class DeleteNotificationsModal extends React.Component {
	state = {

		submitting: false
	}
	deleteCampaigns = async () => {
		const { checkedCampaigns, orgId, eventId, deleteCheckedCampaigns, toggle, isSingleDelete, editedNotification, updateDeleteCampaign } = this.props;
		this.setState({ submitting: true })

		const campaignsIds = !isSingleDelete ? Object.keys(checkedCampaigns) : [editedNotification._id];
		try {
			await API()
				.post(`Organizations/${orgId}/events/${eventId}/notifications/delete`, { notificationIds: campaignsIds })
				.then((res) => {
					if (isSingleDelete) {
						updateDeleteCampaign(editedNotification._id, () => {
							this.props.history.push(`/${orgId}/events/${eventId}/notifications`);
						})

					} else {
						deleteCheckedCampaigns(() => {
							toggle();
						});
					}

				});
		} catch (e) {
			console.log(e);
		}
	};
	render() {
		const { isOpen, toggle, checkedCampaigns, isSingleDelete } = this.props;
		const { submitting } = this.state;

		let campaignCount = !isSingleDelete ? Object.keys(checkedCampaigns).length : 1;

		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle={`Delete Notification${campaignCount > 1 ? 's' : ''}`}
				bodyHeaderText={<span>You are about to delete <b>{campaignCount}</b> notification{campaignCount > 1 ? 's' : ''} from the
					event, this is irreversible, would you like to continue?</span>}
				bodyContent={() => {
					return ("")
				}}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
				actionButton={() => this.deleteCampaigns()}
				isDelete={true}
				actionButtonDisabled={submitting}


			></FieldModal>

		);
	}
}

export default withRouter(DeleteNotificationsModal);
